import React, { useMemo } from 'react';
import { CarChecklistType, ChecklistDataEntry, StudentChecklistValue } from './types';
import { useTranslation } from 'react-i18next';
import { createColumnHelper } from '@tanstack/react-table';
import Table from './Table';
import ChecklistValueCell from './ChecklistValueCell';

type CarChecklistDataEntry = ChecklistDataEntry & {
	healthDeclaration: StudentChecklistValue;
	theoryExam: StudentChecklistValue;
	drivingTest: StudentChecklistValue;
	practicalExam: StudentChecklistValue;
};
const columnHelper = createColumnHelper<CarChecklistDataEntry>();

const CarChecklist = ({ checklist }: { checklist: CarChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('healthDeclaration', {
				header: 'Gezondheidsverklaring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('theoryExam', {
				header: 'Theorie-examen',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('drivingTest', {
				header: 'Tussentijdse toets',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalExam', {
				header: 'Praktijkexamen',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			healthDeclaration: entry.values.find(
				(value) => value.option.name === 'Gezondheidsverklaring',
			) || { value: null },
			theoryExam: entry.values.find((value) => value.option.name === 'Theorie-examen') || {
				value: null,
			},
			drivingTest: entry.values.find((value) => value.option.name === 'Tussentijdse toets') || {
				value: null,
			},
			practicalExam: entry.values.find((value) => value.option.name === 'Praktijkexamen') || {
				value: null,
			},
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default CarChecklist;
